import React from 'react';
import { createIcon } from './create-icon';
import './icon-content.scss';

export const IconContent = createIcon(<div className="icon-content" />);
